module.exports = __webpack_public_path__ + "img/issue_age_white.9991bba.svg";